const inputPlaceholder = (celebrities) => {

    const input = $('.celebrity-top-input-inner input');

    let placeholderIndex = 0;
    let placaholderDireccion = 1;
    let counter = 0;

    setInterval(() => {
        const actualLength = input.attr('placeholder').length
        const newLength = actualLength + placaholderDireccion;

        if (newLength === -1) {
            if (celebrities[placeholderIndex + 1]) placeholderIndex++;
            else placeholderIndex = 0;
            placaholderDireccion = 1;
            return;
        }

        const celebrity = celebrities[placeholderIndex];

        if (celebrity.length < newLength) {
            if (counter < 20) {
                counter++;
                return;
            }
            counter = 0
            placaholderDireccion = -1;
            return;
        }

        const value = celebrity.slice(0, newLength);

        input.attr('placeholder', value);

    }, 100)
}

const loadImage = (search, size) => fetch(`https://en.wikipedia.org/w/api.php?action=opensearch&format=xml&search=${search}&origin=*`)
    .then(response => response.text())
    .then(text => {
        const xmlDocument = $.parseXML(text);
        const url = $(xmlDocument).find('Item').find('Image').attr('source');
        if (!url) return;
        return url.replace(/([0-9]{2})px-/, `${size}px-`)
    })

const loadImages = () => {
    $('tr[data-id]').each(function () {
        const name = $(this).attr('data-name');
        loadImage(name, 100)
            .then(url => {
                if (!url) return;
                $(this).find('img').attr('src', url)
            })
    })
}

$.fn.celebrityCarousel = function () {

    const configElement = $(this).parent().find('.celebrity-carousel-configure');
    const isMobile = !configElement.is(':visible');
    const visibleCelebrity = isMobile ? 1 : 4;
    const buttonText = configElement.attr('data-button-text');

    fetch('/celebrity/popular')
        .then(response => response.json())
        .then(celebrities => {

            const formatedCelebrities = celebrities.reduce((formatedCelebrities, celebrity, index) => {
                const formatedCelebritiesIndex = Math.trunc(index / visibleCelebrity);
                if (!formatedCelebrities[formatedCelebritiesIndex]) formatedCelebrities[formatedCelebritiesIndex] = [];
                formatedCelebrities[formatedCelebritiesIndex].push(celebrity);

                return formatedCelebrities;
            }, []);

            $(this)
                .addClass('carousel')
                .addClass('slide')

            const carouselInner = $('<div />')
                .addClass('carousel-inner')
                .appendTo($(this))

            // Control left
            $('<a />')
                .addClass('carousel-control-prev')
                .append($('<img />').attr('src', 'https://app-mail-asset.bizzw.com/img/celebrity/carousel-arrow-left.svg'))
                .attr('role', 'button')
                .appendTo($(this))
                .on('click', () => $(this).carousel('prev'))

            // Control right
            $('<a />')
                .addClass('carousel-control-next')
                .append($('<img />').attr('src', 'https://app-mail-asset.bizzw.com/img/celebrity/carousel-arrow-right.svg'))
                .attr('role', 'button')
                .appendTo($(this))
                .on('click', () => $(this).carousel('next'))

            formatedCelebrities.forEach((celebrities, index) => {
                const item = $('<div />')
                    .addClass('carousel-item')
                    .appendTo(carouselInner);

                const itemContent = $('<div />')
                    .addClass('row')
                    .appendTo(item);

                if (index === 0) item.addClass('active');

                celebrities.forEach(celebrity => {
                    const element = $('<div />')
                        .addClass('celebrity-carousel-element')
                        .addClass('col-12')
                        .addClass('col-lg-3')
                        .addClass('text-center')
                        .appendTo(itemContent);

                    const imageContainer = $('<div />')
                        .addClass('celebrity-carousel-img-container')
                        .appendTo(element)

                    const image = $('<img />')
                        .attr('src', 'https://app-mail-asset.bizzw.com/img/celebrity/profile-icon.svg')
                        .addClass('img-fluid')
                        .appendTo(imageContainer)

                    loadImage(celebrity.name, 150)
                        .then(url => {
                            if (!url) return;
                            image.attr('src', url)
                        })

                    const elementContent = $('<div />')
                        .addClass('celebrity-carousel-element-content')
                        .appendTo(element)

                    // Name
                    $('<p />')
                        .text(celebrity.name)
                        .appendTo(elementContent)

                    // Send button
                    $('<a />')
                        .text(buttonText)
                        .appendTo(elementContent)
                        .attr('href', `/celebrity/${celebrity.id}`)

                })
            })

            $(this).carousel({ interval: 3000 }).carousel('cycle')
        })
}

const search = (query, size, from) => {
    if (!query) return Promise.resolve([]);

    let url = `/celebrity/search?q=${query}`;

    if (size) url += `&size=${size}`;
    if (from) url += `&from=${from}`;

    return fetch(url, {
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response => response.json())
}

const loadMoreButton = $('#loadMore');
loadMoreButton.hide();

let from = 0;

const renderSearch = (query) => {
    const element = $('#searchDisplay');

    loadMoreButton.hide();

    const isElementEmpty = element.is(':empty');

    search(query, 25, from)
        .then(celebrities => {
            return Promise.all(celebrities.map(celebrity => loadImage(celebrity.name, 100)))
                .then(images => celebrities.map((celebrity, index) => {
                    celebrity.image = images[index];
                    return celebrity
                }))
        })
        .then(celebrities => {
            if (celebrities.length === 0) {
                if(from == 0) element.html($('<p />').addClass('my-5').text(element.attr('data-empty')));
                return;
            }

            if(celebrities.length === 25) loadMoreButton.show();

            from += 25;

            let table = $('<table />').addClass('table');

            if(isElementEmpty) {
                const row = $('<tr />').addClass('d-none').addClass('d-lg-table-row').appendTo(table);
                $('<th/>').text(element.attr('data-picture')).appendTo(row)
                $('<th/>').text(element.attr('data-name')).appendTo(row)
                $('<th/>').appendTo(row);

                element.html(table);
            } else {
                table = element.find('table')
            }

            celebrities.forEach(celebrity => {
                const imageUrl = celebrity.image || 'https://app-mail-asset.bizzw.com/img/celebrity/profile-icon.svg';
                const row = $('<tr />').addClass('celebrity-search-row').appendTo(table);

                // Image
                $('<td />')
                .html($('<div />').addClass('img-container')
                .html($('<img />').addClass('img-fluid').attr('atl', celebrity.name).attr('src', imageUrl)))
                .appendTo(row);

                // Name
                $('<td />')
                .html($('<div />').addClass('celebrity-search-row-name').text(celebrity.name))
                .appendTo(row);

                // Button
                $('<td />').addClass('celebrity-search-row-link')
                .html($('<a />').addClass('button-yellow').attr('href', `/celebrity/${celebrity.id}`).text(element.attr('data-button')))
                .appendTo(row);
            })
        })
}

const autocomplete = () => {
    $('#searchInput').autocomplete({
        minLength: 3,
        source: (request, response) => {
            search(request.term, 10)
                .then(celebrities => response(celebrities.map(celebrity => celebrity.name)))
        },
        select: (event, ui) => {
            window.location.href = `/celebrity/search/?q=${ui.item.value}`;
        }
    })
}

$('.celebrity-carousel-content').celebrityCarousel();
